import React, { useState } from "react";
import WrapperCard from "../../component-lib/Atoms/card/EventEHRWrapperCard";
import useDeviceType from "../../custom-hooks/DeviceType";
import Heading from "../../component-lib/Atoms/heading/EventEHRHeading";
import { REPORT_CONSTANTS } from "./ReportConstants";

import ReportBox from "./reportBox/ReportBox";
import FullScreenDialog from "./reportBox/dailog/FullScreenVisitDialog";
import FullScreenVisitDialog from "./reportBox/dailog/FullScreenVisitDialog";
import FullScreenPatientDialog from "./reportBox/dailog/FullScreenPatientDialog";
import { useDispatch } from "react-redux";
import { getPatientReportsState } from "./ReportScreenSlice";

const ReportsScreen = () => {
  const ListName1 = ["Visit Report"];
  const ListName2 = ["Patient Report"];
  const ListName3 = ["Medication Report"];

  const [selectedReportTab, setSelectedReportTab] = useState<string | null>(
    null
  );
  const dispatch = useDispatch();
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const [visitFilterData, setVisitFilterData] = React.useState({
    typeofCare: "",
    startDate: undefined,
    endDate: undefined,
    type: "",
    //date: undefined,
    status: "",
    sign: "",
    facilityId: "",
  });
  const [patientFilterData, setPatientFilterData] = React.useState({
    patientName: "",
    //assignTo: "",
    //assignBy: "",
    visitType: "",
    startDate: undefined,
    endDate: undefined,
    // IAP operational period (single date -> 0700-0700 ET window). Mutually
    // exclusive with the From/To calendar-date range.
    operationalPeriod: undefined,
    status: "",
    gender: "",
    facilityId: "",
  });
  const [isFilterVisible, setIsFilterVisible] = React.useState(false);

  // Handle the list item click
  const handleListItemClick = (listItem: string) => {
    setSelectedReportTab(listItem);
    setDialogOpen(true);
  };

  const handleDialogCloseForPatient = () => {
    setPatientFilterData({
      patientName: "",
      visitType: "",
      startDate: undefined,
      endDate: undefined,
      operationalPeriod: undefined,
      status: "",
      gender: "",
      facilityId: "",
    });
    setDialogOpen(false);
    dispatch(getPatientReportsState([]));
    setIsFilterVisible(false);
  };
  const handleDialogCloseForVisit = () => {
    setVisitFilterData({
      typeofCare: "",
      startDate: undefined,
      endDate: undefined,
      type: "",
      status: "",
      sign: "",
      facilityId: "",
    });
    setDialogOpen(false);
    dispatch(getPatientReportsState([]));
    setIsFilterVisible(false);
  };
  const deviceType = useDeviceType();
  // };
  return (
    <WrapperCard
      customClasses="m-3 p-3 pl-4 pr-4 flex-1 min-h-0"
      customStyle={{ minWidth: deviceType !== "mobile" ? "400px" : "" }}
    >
      <div className="flex flex-col h-full gap-6">
        {/* Heading and Tabs Section */}
        <div className={`flex items-center justify-between w-full`}>
          {/* Heading */}
          <Heading
            title={REPORT_CONSTANTS?.REPORT}
            customStyle={{ color: "#1D1D1D" }}
          />
        </div>
        {/* Label */}
        <div className="flex flex-wrap gap-[63px] overflow-auto">
          {/* Change gap-0 to a small value like gap-2 */}
          <ReportBox
            title="Visit Report"
            listItems={ListName1}
            onItemClick={(item) => handleListItemClick(item)} // Now it passes the correct item
          />
          <ReportBox
            title="Patient Report"
            listItems={ListName2}
            onItemClick={handleListItemClick}
          />
          {/* <ReportBoxn  
            title="Medication Report"
            listItems={ListName3}
            onItemClick={handleListItemClick}
          /> */}
          {selectedReportTab === "Visit Report" && (
            <FullScreenVisitDialog
              open={dialogOpen}
              handleClose={handleDialogCloseForVisit}
              visitFilterData={visitFilterData}
              setVisitFilterData={setVisitFilterData}
              isFilterVisible={isFilterVisible}
              setIsFilterVisible={setIsFilterVisible}
              selectedReport={selectedReportTab}
            />
          )}
          {selectedReportTab === "Patient Report" && (
            <FullScreenPatientDialog
              open={dialogOpen}
              handleClose={handleDialogCloseForPatient}
              selectedReport={selectedReportTab}
              patientFilterData={patientFilterData}
              setPatientFilterData={setPatientFilterData}
              isFilterVisible={isFilterVisible}
              setIsFilterVisible={setIsFilterVisible}
            />
          )}
        </div>
      </div>
    </WrapperCard>
  );
};

export default ReportsScreen;
